export const ROUTES = {
  ticket: '/ticket/:ticketId/:threadId?',
  new: '/new',
  root: '/'
};